export default __webpack_public_path__ + "static/media/tour-img4.b9400ca6.jpg";